<style lang="less" scoped>
  #detail {
    .order-cancel-btn {
      border: none;
      background: none;
      color: #7ed321;
    }

    .description {
      border-radius: 4px;
      background-color: #f8f8f8;
      padding: 12px;
      margin-bottom: 24px;
    }

    .profile-page-content {
      margin-bottom: 32px;
    }

    .present-list-cover {
      margin: 0 -16px;

      &:after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }
</style>

<template lang="pug">
  #detail(
    v-loading="isLoading",
    v-if="order")
    .area-container.area-container-mobile
      .page-title-area
        h1 {{title}}
        .nav-area
          router-link(to="#")
            el-button(type="success" native-type="button") 주문 내역
      .description
        strong 주문이 정상적으로 처리되었습니다.
        div 조제에 들어가기 전까지 주문을 취소할 수 있습니다.
      .profile-page-content
        // profile-component(:user="user" :status="status")
        profile-component(:order="order")
      .present-list-cover(v-if="order.prescriptions")
        present-card-component(
          v-for="prescription in order.prescriptions",
          :prescription="prescription")
    .mobile.mobile-bottom-ui-cover
      el-button.w10(type="success") 완료
</template>

<script>
import profileComponent from '@/components/profile';
import presentCardComponent from '@/components/present_card';

export default {
  async created() {
    this.$store.commit('setTitle', this.title);

    this.isLoading = true;
    this.orderId = this.$route.params.orderId;
    const { data } = await this.$http.get('/orders/'.concat(this.orderId));
    this.order = data;
    this.isLoading = false;
  },
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      orderId: null,
      order: null,
      isLoading: false,
    };
  },
  components: {
    presentCardComponent,
    profileComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/complete.vue